import React from "react";
import mascot from "../../../../assets/promotionagent.png";

const VisibilityScreen = ({ onStartAnalysis, subsection }) => {
  return (
    <div className="w-full h-full flex flex-col items-center justify-start pt-12 pb-8 px-8 bg-white rounded-[20px]">
      {/* Mascot Image */}
      <div className="mb-4 flex-shrink-0">
        <img
          src={mascot}
          alt="Visibility Agent"
          style={{
            width: "279.62px",
            height: "353.41px",
            objectFit: "contain"
          }}
        />
      </div>

      {/* Welcome Title */}
      <h1 className="text-[28px] leading-[135%] font-medium text-[#323232] mb-6 text-center font-gotham">
        Welcome to the Deep Dive
      </h1>

      {/* Description Text */}
      <p className="text-base leading-[165%] font-normal text-[#323232] text-center max-w-2xl mb-10 px-4 font-gotham">
        Welcome! I'm SiYu, your friendly companion here to help you analyse, probe and grow. Let's embark on this journey of discovering your strengths together!
      </p>

      {/* Start Analysis Button - Changed CTA */}
      <button
        onClick={onStartAnalysis}
        className="flex items-center justify-between bg-[#54B0AF] hover:bg-[#459E9D] text-white font-medium rounded-[20px] px-5 py-[22px] min-w-[252px] transition-all duration-200 shadow-md hover:shadow-lg font-gotham"
      >
        <span className="text-base font-gotham font-medium">Let's Do WIIFM</span>
        <div className="w-[24px] h-[24px] rounded-full bg-white flex items-center justify-center flex-shrink-0">
          <svg
            className="w-[14px] h-[14px]"
            fill="none"
            stroke="#54B0AF"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </div>
      </button>
    </div>
  );
};

export default VisibilityScreen;
